import React from 'react';
import './PaymentsDashboardStyles.scss';
import {
  Button,
  createStyles,
  Dialog,
  makeStyles,
  Slide,
  Theme
} from '@material-ui/core';
import {TransitionProps} from '@material-ui/core/transitions/transition';
import DOMPurify from 'dompurify';
import {useTranslation} from 'react-i18next';
import PhoneNumberFormatter from '@components/system/PhoneNumberFormatter/PhoneNumberFormatter';

// Styling of the component
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialogContainer: {
      padding: '24px 24px 12px 24px',
      display: 'flex',
      flexDirection: 'column',
      height: '100%'
    },
    dialogContainerFull: {
      height: 'calc(90vh - 64px)'
    },
    clinicLine: {
      fontSize: '1.125rem'
    },
    dialogTitle: {
      padding: '8px 0',
      fontSize: '1.25rem',
      fontWeight: 700
    },
    dialogContent: {
      padding: '8px 0',
      fontSize: '1.125rem',
      lineHeight: '1.5rem',
      height: '100%',
      overflow: 'auto'
    },
    dialogActions: {
      display: 'flex',
      flexDirection: 'column-reverse',
      padding: '12px 0'
    }
  })
);

interface GuarantorNoticeProps {
  title: string;
  description: string;
  fullScreen?: boolean;
  clinicDetails: {
    name: string;
    address: string;
    city: string;
    state: string;
    zip: string;
    phone: string;
  };
  onClose(): void;
}

const GuarantorNotice = (props: GuarantorNoticeProps): React.ReactElement => {
  const styles = useStyles();
  const {t} = useTranslation();

  const {title, description, fullScreen, clinicDetails, onClose} = props;

  const handleClose = React.useCallback((): void => {
    if (typeof onClose === 'function') {
      onClose();
    }
  }, [onClose]);
  return (
    <div className={'payments-dashboard-wrapper'}>
      <Dialog
        TransitionComponent={React.forwardRef(function Transition(
          props1: TransitionProps & {children?: React.ReactElement<any, any>},
          ref: React.Ref<unknown>
        ) {
          return <Slide direction="up" ref={ref} {...props1} />;
        })}
        open={true}
        fullScreen={fullScreen}
        onClose={handleClose}
        aria-labelledby="confirm-dialog"
        aria-describedby="confirm-dialog"
        disableBackdropClick={true}>
        <div
          className={[
            styles.dialogContainer,
            !fullScreen && styles.dialogContainerFull
          ].join(' ')}>
          <div className={styles.dialogTitle}>{title}</div>
          <div className={styles.dialogContent}>
            <div className={styles.clinicLine}>{clinicDetails.name}</div>
            <div className={styles.clinicLine}>{clinicDetails.address}</div>
            <div className={styles.clinicLine}>
              {clinicDetails.city},&nbsp;
              {clinicDetails.state},&nbsp;
              {clinicDetails.zip}
            </div>
            <div className={styles.clinicLine}>
              {clinicDetails.phone ? (
                <PhoneNumberFormatter value={clinicDetails.phone} />
              ) : (
                ''
              )}
            </div>
            <br />
            <br />
            <div
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(description)
              }}
            />
          </div>
          <div className={styles.dialogActions}>
            <Button
              variant={'contained'}
              color={'primary'}
              onClick={handleClose}>
              {t('PAYMENTS_LOGIN.NOTICE.CLOSE')}
            </Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default GuarantorNotice;
